import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { KeyRound } from 'lucide-react';

const ResetPasswordDialog = ({
  open, onOpenChange, step, resetEmail, setResetEmail,
  resetCode, setResetCode, generatedCode, newPassword, setNewPassword,
  onRequest, onVerify, onReset, onCancel
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="surface-card border-0 shadow-xl">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
          <KeyRound className="w-5 h-5 text-cyan-600" /> Reset Password
        </DialogTitle>
        <DialogDescription>
          {step === 1 && "Enter your email to get a reset code"}
          {step === 2 && "Enter the 6-digit code"}
          {step === 3 && "Choose a new password"}
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-4">
        {step === 1 && (
          <>
            <div className="space-y-1.5">
              <Label>Email Address</Label>
              <Input type="email" placeholder="you@example.com" value={resetEmail} onChange={(e) => setResetEmail(e.target.value)} className="rounded-xl" />
            </div>
            <Button onClick={onRequest} className="w-full btn-primary">Get Reset Code</Button>
          </>
        )}

        {step === 2 && (
          <>
            {generatedCode && (
              <div className="bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-700 rounded-xl p-4">
                <p className="text-xs text-amber-700 dark:text-amber-300 font-medium">Your reset code:</p>
                <p className="text-2xl font-bold text-amber-900 dark:text-amber-100 text-center my-2 tracking-widest">{generatedCode}</p>
                <p className="text-xs text-amber-600 dark:text-amber-400">Copy and paste below</p>
              </div>
            )}
            <div className="space-y-1.5">
              <Label>6-Digit Code</Label>
              <Input type="text" placeholder="000000" maxLength={6} value={resetCode} onChange={(e) => setResetCode(e.target.value.replace(/\D/g, ''))} className="text-center text-xl tracking-widest rounded-xl" />
            </div>
            <Button onClick={onVerify} className="w-full btn-primary">Verify Code</Button>
          </>
        )}

        {step === 3 && (
          <>
            <div className="space-y-1.5">
              <Label>New Password</Label>
              <Input type="password" placeholder="At least 6 characters" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="rounded-xl" />
            </div>
            <Button onClick={onReset} className="w-full btn-primary">Reset Password</Button>
          </>
        )}

        <Button variant="ghost" onClick={onCancel} className="w-full rounded-full">Cancel</Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default ResetPasswordDialog;
